// extracted by mini-css-extract-plugin
export var bar = "ApartmentPage-module--bar--1u_bk";
export var backLink = "ApartmentPage-module--backLink--3kbn1";
export var wrapper = "ApartmentPage-module--wrapper--29zCS";
export var inner = "ApartmentPage-module--inner--2jrr_";